export default {
    trailerSrc: '',
    episodeTitle: '',
    episodeDesc: '',
    permalink: '',
    id: '',
    newsTrayId: '',
    contentType: '',
    seriesDatas: {},
    video: null
}